(function () {
  if (window.__lpPdpMediaFallback) return;
  window.__lpPdpMediaFallback = true;

  const selector = '.product-information img, .lp-pdp__image img';

  function originalUrl(image, attempt) {
    const source = image.currentSrc || image.src;
    if (!source) return '';
    const url = new URL(source, window.location.href);
    url.searchParams.delete('width');
    url.searchParams.set('lp_media_retry', `${attempt}-${Date.now()}`);
    return url.href;
  }

  function retry(image) {
    if (!(image instanceof HTMLImageElement) || !image.matches(selector)) return;
    const attempt = Number(image.dataset.lpMediaRetries || 0) + 1;
    if (attempt > 3) return;
    image.dataset.lpMediaRetries = String(attempt);
    const fallback = originalUrl(image, attempt);
    if (!fallback) return;
    window.setTimeout(() => {
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.src = fallback;
    }, attempt * 150);
  }

  document.addEventListener('error', (event) => retry(event.target), true);

  function checkImages() {
    document.querySelectorAll(selector).forEach((image) => {
      if (image.complete && image.naturalWidth === 0) retry(image);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkImages, { once: true });
  } else {
    checkImages();
  }
  window.addEventListener('load', checkImages, { once: true });
})();
